import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Box,
  Chip,
} from "@mui/material";

const SubscriptionDetails = ({ subscriptionData, counts }) => {
  if (!subscriptionData?.subscription) return null;

  const {
    expiredDate,
    startDate,
    subscription: { name, description, subscriptionServices },
  } = subscriptionData;

  return (
    <Card elevation={3}>
      <CardContent>
        <Box display="flex" justifyContent="flex-start" flexWrap="wrap" gap={2}>
          <Typography variant="body1">
            <strong>Name:</strong> {name || ""}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            <strong>Description:</strong> {description || "-"}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box
          display="flex"
          justifyContent="flex-start"
          flexWrap="wrap"
          gap={2}
          mb={2}
        >
          <Typography variant="body2" color="text.secondary">
            <strong>Start Date:</strong>{" "}
            {new Date(startDate).toLocaleDateString()}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Expired Date:</strong>{" "}
            {new Date(expiredDate).toLocaleDateString()}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Status:</strong>{" "}
            {new Date(expiredDate) < new Date() ? (
              <Chip label="Expired" color="error" size="small" />
            ) : (
              <Chip label="Active" color="success" size="small" />
            )}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          Subscription Services
        </Typography>

        <Grid container spacing={2} mb={3}>
          {subscriptionServices?.map((service) => (
            <Grid item xs={12} sm={4} md={3} key={service.id}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="subtitle1">{service.name}</Typography>
                  <Chip
                    label={service.value}
                    color={service.value === "on" ? "success" : "primary"}
                    variant="outlined"
                    sx={{ mt: 1 }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {counts && (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" gutterBottom>
              Usage Summary
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle2">Total Users</Typography>
                <Typography variant="body1" color="text.primary">
                  {counts.staffs}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle2">Total Stores</Typography>
                <Typography variant="body1" color="text.primary">
                  {counts.stores}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle2">
                  Total Products (SKUs)
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {counts.skus}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default SubscriptionDetails;
